import { ensureJourneyDb, getById, insertRow, listTable, updateRow, writeAudit } from "../db";
import { DEMO_IDS, createBetaFeedback } from "../db/schema";
import { postInquirySend } from "./messaging/inquiries";

export function listBetaFeedback() {
  ensureJourneyDb();
  return [...listTable("beta_feedback")].sort((a, b) =>
    String(b.created_at).localeCompare(String(a.created_at))
  );
}

export function listBetaTesters() {
  ensureJourneyDb();
  return listTable("users").filter((row) => row.betaTester);
}

export function updateBetaFeedback(id, patch) {
  ensureJourneyDb();
  return updateRow("beta_feedback", id, patch);
}

export function recordBetaFeedback({
  session,
  message_text,
  message_id = null,
  thread_id = null,
  mirrorToOffice = true,
}) {
  ensureJourneyDb();
  const text = String(message_text || "").trim();
  if (!text) throw new Error("Feedback text is required");
  const row = insertRow(
    "beta_feedback",
    createBetaFeedback({
      user_id: session?.userId || null,
      message_id,
      thread_id,
      tag: "betaFeedback",
      message_text: text,
      from_name: session?.name || "",
      from_email: session?.email || "",
      from_role: session?.betaRole || session?.role || "",
    })
  );
  writeAudit({
    user_id: session?.userId || null,
    action_type: "beta.feedback",
    metadata: { feedback_id: row.id, thread_id, message_id },
  });

  if (mirrorToOffice && session && (session.role === "agent" || session.role === "broker")) {
    const recipientId = session.userId === DEMO_IDS.broker ? DEMO_IDS.agent : DEMO_IDS.broker;
    try {
      const inquiry = postInquirySend(
        {
          to_user_id: recipientId,
          message_text: text,
          tag: "betaFeedback",
        },
        session
      );
      return updateRow("beta_feedback", row.id, {
        message_id: inquiry.message?.id || row.message_id,
        thread_id: inquiry.thread_id || row.thread_id,
      });
    } catch {
      return row;
    }
  }
  return row;
}

export function taggedMessages() {
  ensureJourneyDb();
  return listTable("messages").filter((row) => row.tag === "betaFeedback");
}

export function getBetaUser(id) {
  return getById("users", id);
}
